module.exports = __webpack_public_path__ + "img/logo.226e7643.svg";